// extracted by mini-css-extract-plugin
export default {"root":"o5qjRrzMfKaetcK9rOsm"};